exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".options-sty[data-v-8c1728b8]{color:#290202}.action .span[data-v-8c1728b8]{margin-right:5px;display:inline-block;cursor:pointer}.deal-type[data-v-8c1728b8]{max-width:1200px;margin:10px auto 0}.deal-type .pageation[data-v-8c1728b8]{padding:30px 10px 20px;border-top:0}.deal-type .dialog-footer[data-v-8c1728b8]{padding-bottom:20px}.deal-type .dialog-footer .btn[data-v-8c1728b8]{width:30%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8c1728b8","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/signInfo/viewDealTypeList.vue
// module id = bZ9n
// module chunks = 185